// Module
var code = "<template> <div class=\"pages-content\"></div> </template> ";
// Exports

  export default (function() {
    return function parseDOMString(tagString) {

  function prepare () {
    let range = document.createRange();
    let node = range.createContextualFragment(tagString);
    let firstChild = node.firstElementChild;

    if (firstChild && firstChild.tagName.toLowerCase() === 'template') {
      var parts = navigator.userAgent.match(/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i);
      if (parts && parts[1] == 'Trident' && parts[2] == '11.0' ) {
        node = range.createContextualFragment(firstChild.innerHTML);
      } else {
        node = firstChild.content;
      }
    } else {
      console.warn(tagString);
    }
    return node;
  }

  return {
    node : null,
    getNode: function() {
      if(!this.node) {
        this.node = prepare();
      }
      return document.importNode(this.node,true);
    }
  };
}(code);
  })()